export function getLoadingTimeoutInMillis(): number {
  const seconds =
    process.env.REACT_APP_UNSUBSCRIBE_LOADING_TIMEOUT_IN_SECONDS ?? '30'
  return parseInt(seconds, 10) * 1000
}
